var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsIn, IsInt, IsOptional, IsString, IsUrl } from 'class-validator';
import { MediaSummary } from '../../commons/medias/media';
import { HighlightTypeValues } from './highlight-type';
/**
 * Affected endpoints
 * GET /manfredite/highlights
 * POST /manfredite/highlights/<id>
 * PUT /manfredite/highlights/<id>
 */
export class HighlightResponse {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], HighlightResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    IsIn(HighlightTypeValues),
    __metadata("design:type", String)
], HighlightResponse.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], HighlightResponse.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], HighlightResponse.prototype, "category", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], HighlightResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], HighlightResponse.prototype, "date", void 0);
__decorate([
    Expose(),
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], HighlightResponse.prototype, "technologies", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", MediaSummary)
], HighlightResponse.prototype, "logo", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsUrl({ require_protocol: true }),
    __metadata("design:type", String)
], HighlightResponse.prototype, "url", void 0);
//# sourceMappingURL=highlight.response.js.map